import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';

import {
  GetMessageQueuesQuery,
  GetMessageQueuesResponse,
} from '@hud/portal-dtos/webapp-message-queue.dto';
import { faro } from '@grafana/faro-react';
import { PORTAL_BASE } from '../consts';

export const QUEUES_ID = 'MessageQueues';

export default function useMessageQueues(params: GetMessageQueuesQuery) {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [QUEUES_ID, params],
    queryFn: async () => {
      const startTime = new Date();
      const response = await client.get<GetMessageQueuesResponse>(
        `${PORTAL_BASE}/messageQueues`,
        {
          params,
        },
      );
      faro.api.pushMeasurement({
        type: 'geMessageQueues',
        values: {
          time: new Date().getTime() - startTime.getTime(),
        },
      });
      return GetMessageQueuesResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
